import {
  VIBE_CODING_GENERATE_VIBE_RESPONSE_DISMISS_ERROR,
  VIBE_CODING_PLAN_FAILURE,
  VIBE_CODING_PLAN_SUCCESS,
} from './constants';
import { fetchVibeRunState } from '../services/vibePlanService';
import {
  hasActivePlanProposal,
  normalizePlanProposal,
} from '../../../features-v2/vibe-coding/utils/planUtils';

export const getVibeRunState =
  (args = {}) =>
  async (dispatch) => {
    try {
      const data = await fetchVibeRunState(args);
      if (data) dispatch({ type: VIBE_CODING_PLAN_SUCCESS, data });
      return data;
    } catch (error) {
      dispatch({ type: VIBE_CODING_PLAN_FAILURE, data: { error } });
      throw error;
    }
  };

export function reducer(state, action) {
  switch (action.type) {
    case VIBE_CODING_PLAN_SUCCESS: {
      const data = normalizePlanProposal(action.data || {}) || action.data || {};
      const milestones =
        data.milestones && data.milestones.length ? data.milestones : state.milestones;
      const buildComplete = data.status === 'completed';
      const hasPlan = !buildComplete && hasActivePlanProposal(data);
      const prompt = typeof data.prompt === 'string' ? data.prompt.trim() : '';
      const promptAlreadyRecorded = state.messages.some(
        (message) => message && message.role === 'user' && message.content === prompt,
      );
      const nextMessages =
        prompt && hasPlan && !promptAlreadyRecorded
          ? [
              ...state.messages,
              {
                id: `plan-user-${Date.now()}`,
                role: 'user',
                content: prompt,
                createdAt: new Date().toISOString(),
              },
            ]
          : state.messages;
      return {
        ...state,
        planPending: false,
        generateVibeResponsePending: false,
        planError: null,
        conversationId: data.conversationId || state.conversationId,
        planProposal: hasPlan ? data : buildComplete ? null : state.planProposal,
        milestones: buildComplete
          ? milestones.map((step) => ({ ...step, status: 'completed' }))
          : milestones,
        messages: nextMessages,
      };
    }
    case VIBE_CODING_PLAN_FAILURE: {
      const data = action.data || {};
      return {
        ...state,
        planPending: false,
        generateVibeResponsePending: false,
        planError: data.error,
      };
    }
    case VIBE_CODING_GENERATE_VIBE_RESPONSE_DISMISS_ERROR:
      return { ...state, planError: null };
    default:
      return state;
  }
}
